/*
 * @Author: huangzq
 * @Date: 2020-04-13 16:48:03
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-13 16:48:03
 * @Desc: 表格状态组件
*/
<template>
  <div class="list-table-status">
    <span
      class="icon"
      :style="{backgroundColor:currStatus.backgroundColor}"
    />
    {{ currStatus.text }}
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  computed: {
    currStatus () {
      return this.item.statusMap[this.scope.row.status]
    }
  }
}
</script>
<style lang="scss" scoped>
.list-table-status {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #595959;

  .icon {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>
